module.exports = "<footer>\n    <div class=\"container-fluid wrapper-page\">\n      <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span>&copy; 2017 Radmirtech</span></div>\n      </div>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/footer/footer.template.html
// module id = ../../../../../src/app/components/footer/footer.template.html
// module chunks = main